import overview from './overview'
import audit from './audit'
import auditSumary from './auditSumary'
import errorFinding from './errorFinding'
import findingRule from './findingRule'
import finding from './finding'
import reports from './reports'
import report from './report'
import masterData from './masterData'
import entity from './entity'
import transactions from './transactions'
import repository from './repository'
import generationRepository from './generationRepository'
import entityWithoutHeader from './entityWithoutHeader'
import efaturaTransactionalData from "./efaturaTransactionalData";
import efaturaOverviewData from "./efaturaOverviewData";
import isafMasterData from './isafMasterData'
import isafTransactions from './isafTransactions'
import defaultNavigation from "./navigation"
import overviewSaftLt from './overviewSaftLt';
import overviewErp from './overviewErp';
import statement from './statement'
import efaturaMasterData from './efaturaMasterData'
import efaturaAuditFindings from './efaturaAuditFindings'
import dashboardBill from "./dashboardBill";
import dashboardEInvoice from "./dashboardEInvoice";
import entitiesDataWithoutFindings from "./entitiesDataWithoutFindings";
import gstReturnToSubmit from "./gstReturnToSubmit";
import entityWithoutFindings from "./entityWithoutFindings";
import saftAoOverview from './overviewSaftAo';
import reportSaftAo from './reportSaftAo'
import fileSubmission from './fileSubmission';

let navigation = []

const menuRouting = {
	'ewaybill': [
		{
			level: 0,
			priority: 1,
			name: "label(Dashboard EWayBill)",
			to: "/:projectId/:fiscalYear([0-9]{4})/",
			exact: true,
			icon: 'dashboard',
			routing: [
				dashboardBill(
					"/:locale(pt|en|lt|es)?/:projectId/:fiscalYear([0-9]{4}|current)?/",
					navigation,
					true,
					"label(Dashboard)"
				),
			],
		},
	],
	'in_einvoice': [
		{
			level: 0,
			priority: 2,
			name: "label(Dashboard E-Invoice)",
			to: "/:projectId/:fiscalYear([0-9]{4})/",
			exact: true,
			icon: 'dashboard',
			routing: [
				dashboardEInvoice(
					"/:locale(pt|en|lt|es)?/:projectId/:fiscalYear([0-9]{4}|current)?/",
					navigation,
					true,
					"label(Dashboard)"
				),
			],
		},
		{
			name: "label(E-Invoices)",
			icon: 'master-data',
			priority: 5,
			level: 0,
			isToBuildMenu: true,
			navigation: "prop(einvoiceData)",
			routing: [
				entitiesDataWithoutFindings(
					"/:locale(en|lt)?/:projectId/:fiscalYear([0-9]{4}|current)/:modulePrefix(in_einvoice)/:entity?",
					navigation,
					true,
					["label(E-Invoices Data)", "label(param(entity))"]
				),
				entityWithoutFindings(
					"/:locale(en|lt)?/:projectId/:fiscalYear([0-9]{4}|current)/:modulePrefix(in_einvoice)/:entities*",
					navigation,
					true,
					"label(E-Invoices Data)"
				),
			],
			queries: [
				{
					resource: "einvoice_data",
					args: {
						projectId: "",
						fiscalYear: "",
						modulePrefixInEinvoice: 'in_einvoice'
					},
					body: "entity, count",
				}
			]
		},
	],
	'in_gstr': [
		{
			name: 'label(GST Returns)',
			icon: 'master-data',
			priority: 3,
			level: 0,
			isToBuildMenu: true,
			navigation: 'prop(gstData)',
			routing: [
				gstReturnToSubmit(
					"/:locale(pt|en|lt|es)?/:projectId/:fiscalYear([0-9]{4}|current)/:modulePrefix(in_gstr)/:entity(gst_return_submit)",
					navigation,
					true,
				),
				entitiesDataWithoutFindings(
					"/:locale(pt|en|lt|es)?/:projectId/:fiscalYear([0-9]{4}|current)/:modulePrefix(in_gstr)/:entity?",
					navigation,
					true,
					["label(GST Returns)", "label(param(entity))"]
				),
				entityWithoutFindings(
					"/:locale(pt|en|lt|es)?/:projectId/:fiscalYear([0-9]{4}|current)/:modulePrefix(in_gstr)/:entities*",
					navigation,
					true,
					"label(GST Data)"
				),
			],
			queries: [
				{
					resource: "gst_data",
					args: {
						projectId: "",
						fiscalYear: "",
						modulePrefixInGstr: 'in_gstr'
					},
					body: "entity, count",
				}
			]
		},
	],
	'in_ewaybill': [
		{
			name: "label(Ewaybills)",
			icon: 'master-data',
			priority: 4,
			level: 0,
			isToBuildMenu: true,
			navigation: "prop(ewaybillData)",
			routing: [
				entitiesDataWithoutFindings(
					"/:locale(en|lt)?/:projectId/:fiscalYear([0-9]{4}|current)/:modulePrefix(in_ewaybill)/:entity?",
					navigation,
					true,
					["label(Ewaybills Data)", "label(param(entity))"]
				),
				entityWithoutFindings(
					"/:locale(en|lt)?/:projectId/:fiscalYear([0-9]{4}|current)/:modulePrefix(in_ewaybill)/:entities*",
					navigation,
					true,
					"label(Ewaybills Data)"
				),
			],
			queries: [
				{
					resource: "ewaybill_data",
					args: {
						projectId: "",
						fiscalYear: "",
						modulePrefixInEwaybill: 'in_ewaybill'
					},
					body: "entity, count",
				}
			]
		},
	],
	'saft_pt': [
		{
			level: 0,
			priority: 1,
			name: 'label(Overview)',
			to: '/:projectId/:fiscalYear([0-9]{4})/',
			exact: true,
			icon: 'dashboard',
			routing: [
				overview('/:locale(pt|en|lt|es)?/:projectId/:fiscalYear([0-9]{4}|current)?/', navigation, true, 'label(Overview)'),
			],
			queries: [
				{
					resource: "saft_pt_audit_summary",
					args: {
						projectId: '',
						fiscalYear: '',
						modulePrefix: 'saft_pt'
					},
					body: "severity, count"
				},
			]
		},
		{
			level: 0,
			priority: 2,
			name: 'label(Audit)',
			icon: 'audit-icon',
			badge: 'prop(saftPtAuditSummaryTotal)',
			isToBuildMenu: true,
			navigation: [
				{
					name: ['label(Results)', ' (', 'prop(saftPtAuditSummaryTotal)', ')'],
					to: '/:projectId/:fiscalYear([0-9]{4})/saft_pt/audit',
				},
				{
					name: 'label(Execution Summary)',
					to: '/:projectId/:fiscalYear([0-9]{4})/saft_pt/audit_execution_summary'
				},
				{
					name: 'label(taxonomy_anomaly)',
					to: `/:projectId/:fiscalYear([0-9]{4})/audit_taxonomy_anomaly`,
				},
			],
			routing: [
				audit('/:locale(pt|en|lt|es)?/:projectId/:fiscalYear([0-9]{4}|current)/:modulePrefix(saft_pt)/audit/', navigation, true, 'label(Audit)'),
				auditSumary('/:locale(pt|en|lt|es)?/:projectId/:fiscalYear([0-9]{4}|current)/:modulePrefix(saft_pt)/audit_execution_summary', navigation, true, 'label(Execution Summary)'),
				errorFinding('/:locale(pt|en|lt|es)?/:projectId/audit_findings', navigation, true, 'label(Findings)'),
				finding('/:locale(pt|en|lt|es)?/:projectId/:fiscalYear([0-9]{4}|current)/:modulePrefix(saft_pt)/audit/rules/:entityId/finding/:id', navigation, true, 'label(Finding)'),
				findingRule('/:locale(pt|en|lt|es)?/:projectId/:fiscalYear([0-9]{4}|current)/:modulePrefix(saft_pt)/audit/rules/:id', navigation, true, 'label(Rules)'),
			],
			queries: [
				{
					resource: "saft_pt_audit_summary_total",
					args: {
						projectId: '',
						fiscalYear: '',
						modulePrefix: 'saft_pt'
					},
					body: ""
				},
			]
		},
		{
			priority: 2,
			name: 'label(Reports)',
			icon: 'reports',
			level: 0,
			navigation: [
				{
					name: 'label(Financial Reports)',
					exact: false,
					icon: 'invoices',
					level: 1,
					navigation: [
						{
							name: 'label(balance_taxonomy_annual)',
							to: `/:projectId/:fiscalYear([0-9]{4})/reports/balance_taxonomy_annual`,
							level: 2,
						},
						{
							name: 'label(profit_and_loss_taxonomy_annual)',
							to: `/:projectId/:fiscalYear([0-9]{4})/reports/profit_and_loss_taxonomy_annual`,
							level: 2,
						},
						{
							name: 'label(Trial Balance)',
							to: '/:projectId/:fiscalYear([0-9]{4})/reports/trial_balance',
							level: 2,
						},
						{
							name: 'label(trial_balance_annual)',
							to: '/:projectId/:fiscalYear([0-9]{4})/reports/trial_balance_annual',
							level: 2,
						},
						{
							name: 'label(trial_balance_taxonomy_current_year)',
							to: '/:projectId/:fiscalYear([0-9]{4})/reports/trial_balance_taxonomy_current_year',
							level: 2,
						},
						{
							name: 'label(trial_balance_taxonomy_annual)',
							to: '/:projectId/:fiscalYear([0-9]{4})/reports/trial_balance_taxonomy_annual',
							level: 2,
						},
						{
							name: 'label(statement_accounts_accumulated)',
							to: `/:projectId/:fiscalYear([0-9]{4})/reports/statement_accounts_accumulated`,
							level: 2,
						},
						{
							name: 'label(offsetting_account)',
							to: `/:projectId/:fiscalYear([0-9]{4})/reports/offsetting_account`,
							level: 2,
						}
					]
				},
				{
					name: 'label(Sales Reports)',
					exact: false,
					icon: 'reports',
					level: 1,
					navigation: [
						{
							name: 'label(customers_report)',
							to: `/:projectId/:fiscalYear([0-9]{4})/accounting_reports/customer_sales_report`,
							level: 2,
						},
						{
							name: 'label(products_report)',
							to: `/:projectId/:fiscalYear([0-9]{4})/accounting_reports/product_sales_report`,
							level: 2,
						},
						{
							name: 'label(products_by_country_report)',
							to: `/:projectId/:fiscalYear([0-9]{4})/accounting_reports/sales_by_country_report`,
							level: 2,
						},
					]
				},
			],
			routing: [
				reports('/:locale(pt|en|lt|es)?/:projectId/:fiscalYear([0-9]{4}|current)/reports', navigation, true, 'label(Reports)'),
				report('/:locale(pt|en|lt|es)?/:projectId/:fiscalYear([0-9]{4}|current)/reports/:id', navigation, true, 'label(Reports)'),
				report('/:locale(pt|en|lt|es)?/:projectId/:fiscalYear([0-9]{4}|current)/audit_:id(taxonomy_anomaly)', navigation, true, 'label(Audit)'),
				report('/:locale(pt|en|lt|es)?/:projectId/:fiscalYear([0-9]{4}|current)/accounting_reports/:id', navigation, true, 'label(Sales Reports)'),
			],
		},
		{
			name: 'label(SAF-T)',
			icon: 'xml-file',
			priority: 5,
			level: 0,
			isToBuildMenu: true,
			navigation: [
				{
					level: 1,
					name: 'label(Master Data)',
					icon: 'master-data',
					navigation: 'prop(masterData)',
				},
				{
					level: 1,
					name: 'label(TransactionsMenu)',
					icon: 'transactions',
					navigation: 'prop(transactionalData)'
				},
			],
			routing: [
				masterData('/:locale(pt|en|lt|es)?/:projectId/:fiscalYear([0-9]{4}|current)/:modulePrefix(saft_pt)/master_data/:entity?', navigation, true, 'label(Master Data)'),
				entity('/:locale(pt|en|lt|es)?/:projectId/:fiscalYear([0-9]{4}|current)/:modulePrefix(saft_pt)/master_data/:entities*', navigation, true, 'label(Master Data)'),
				transactions('/:locale(pt|en|lt|es)?/:projectId/:fiscalYear([0-9]{4}|current)/:modulePrefix(saft_pt)/:entity', navigation, true, 'label(TransactionsMenu)'),
				entity('/:locale(pt|en|lt|es)?/:projectId/:fiscalYear([0-9]{4}|current)/:modulePrefix(saft_pt)/:entities*', navigation, true, 'label(TransactionsMenu)'),
			],
			queries: [
				{
					resource: "master_data",
					subEntity: "master_data",
					args: {
						projectId: '',
						fiscalYear: '',
						modulePrefixSaftPt: 'saft_pt'
					},
					body: "entity, count"
				},
				{
					resource: "transactional_data",
					args: {
						projectId: '',
						fiscalYear: '',
						modulePrefixSaftPt: 'saft_pt'
					},
					body: "entity, count"
				},
			]
		},
	],
	'saft_ao': [
		{
			level: 0,
			priority: 1,
			name: 'label(Overview)',
			to: '/:projectId/:fiscalYear([0-9]{4})/',
			exact: true,
			icon: 'dashboard',
			routing: [
				saftAoOverview('/:locale(pt|en|lt|es)?/:projectId/:fiscalYear([0-9]{4}|current)?/', navigation, true, 'label(Overview)'),
			],
			queries: [
				{
					resource: "saft_ao_audit_summary",
					args: {
						projectId: '',
						fiscalYear: '',
						modulePrefix: 'saft_ao'
					},
					body: "severity, count"
				},
			]
		},
		{
			level: 0,
			priority: 2,
			name: 'label(Audit)',
			icon: 'audit-icon',
			badge: 'prop(saftAoAuditSummaryTotal)',
			isToBuildMenu: true,
			navigation: [
				{
					name: ['label(Results)', ' (', 'prop(saftAoAuditSummaryTotal)', ')'],
					to: '/:projectId/:fiscalYear([0-9]{4})/saft_ao/audit',
				},
				{
					name: 'label(Execution Summary)',
					to: '/:projectId/:fiscalYear([0-9]{4})/saft_ao/audit_execution_summary'
				},
			],
			routing: [
				audit('/:locale(pt|en|lt|es)?/:projectId/:fiscalYear([0-9]{4}|current)/:modulePrefix(saft_ao)/audit/', navigation, true, 'label(Audit)'),
				auditSumary('/:locale(pt|en|lt|es)?/:projectId/:fiscalYear([0-9]{4}|current)/:modulePrefix(saft_ao)/audit_execution_summary', navigation, true, 'label(Execution Summary)'),
				errorFinding('/:locale(pt|en|lt|es)?/:projectId/audit_findings', navigation, true, 'label(Findings)'),
				finding('/:locale(pt|en|lt|es)?/:projectId/:fiscalYear([0-9]{4}|current)/:modulePrefix(saft_ao)/audit/rules/:entityId/finding/:id', navigation, true, 'label(Finding)'),
				findingRule('/:locale(pt|en|lt|es)?/:projectId/:fiscalYear([0-9]{4}|current)/:modulePrefix(saft_ao)/audit/rules/:id', navigation, true, 'label(Rules)'),
			],
			queries: [
				{
					resource: "saft_ao_audit_summary_total",
					args: {
						projectId: '',
						fiscalYear: '',
						modulePrefix: 'saft_ao'
					},
					body: ""
				},
			]
		},
		{
			priority: 2,
			name: 'label(Reports)',
			icon: 'reports',
			level: 0,
			navigation: [
				{
					name: 'label(Financial Reports)',
					exact: false,
					icon: 'invoices',
					level: 1,
					navigation: [
						{
							name: 'label(Trial Balance)',
							to: '/:projectId/:fiscalYear([0-9]{4})/saft_ao/reports/trial_balance',
							level: 2,
						},
						{
							name: 'label(trial_balance_annual)',
							to: '/:projectId/:fiscalYear([0-9]{4})/saft_ao/reports/trial_balance_annual',
							level: 2,
						},
						{
							name: 'label(statement_accounts_accumulated)',
							to: `/:projectId/:fiscalYear([0-9]{4})/saft_ao/reports/statement_accounts_accumulated`,
							level: 2,
						},
						{
							name: 'label(offsetting_account)',
							to: `/:projectId/:fiscalYear([0-9]{4})/saft_ao/reports/offsetting_account`,
							level: 2,
						}
					]
				},
				{
					name: 'label(Sales Reports)',
					exact: false,
					icon: 'reports',
					level: 1,
					navigation: [
						{
							name: 'label(customers_report)',
							to: `/:projectId/:fiscalYear([0-9]{4})/saft_ao/accounting_reports/customer_sales_report`,
							level: 2,
						},
						{
							name: 'label(products_report)',
							to: `/:projectId/:fiscalYear([0-9]{4})/saft_ao/accounting_reports/product_sales_report`,
							level: 2,
						},
						{
							name: 'label(products_by_country_report)',
							to: `/:projectId/:fiscalYear([0-9]{4})/saft_ao/accounting_reports/sales_by_country_report`,
							level: 2,
						},
					]
				},
			],
			routing: [
				reportSaftAo('/:locale(pt|en|lt|es)?/:projectId/:fiscalYear([0-9]{4}|current)/:modulePrefix(saft_ao)/reports/:id', navigation, true, 'label(Reports)'),
				reportSaftAo('/:locale(pt|en|lt|es)?/:projectId/:fiscalYear([0-9]{4}|current)/:modulePrefix(saft_ao)/accounting_reports/:id', navigation, true, 'label(Sales Reports)'),
			],
		},
		{
			name: 'label(SAF-T)',
			icon: 'xml-file',
			priority: 5,
			level: 0,
			isToBuildMenu: true,
			navigation: [
				{
					level: 1,
					name: 'label(Master Data)',
					icon: 'master-data',
					navigation: 'prop(saftAoMasterData)',
				},
				{
					level: 1,
					name: 'label(TransactionsMenu)',
					icon: 'transactions',
					navigation: 'prop(saftAoTransactionalData)'
				},
			],
			routing: [
				masterData('/:locale(pt|en|lt|es)?/:projectId/:fiscalYear([0-9]{4}|current)/:modulePrefix(saft_ao)/master_data/:entity?', navigation, true, 'label(Master Data)'),
				entity('/:locale(pt|en|lt|es)?/:projectId/:fiscalYear([0-9]{4}|current)/:modulePrefix(saft_ao)/master_data/:entities*', navigation, true, 'label(Master Data)'),
				transactions('/:locale(pt|en|lt|es)?/:projectId/:fiscalYear([0-9]{4}|current)/:modulePrefix(saft_ao)/:entity', navigation, true, 'label(TransactionsMenu)'),
				entity('/:locale(pt|en|lt|es)?/:projectId/:fiscalYear([0-9]{4}|current)/:modulePrefix(saft_ao)/:entities*', navigation, true, 'label(TransactionsMenu)'),
			],
			queries: [
				{
					resource: "saft_ao_master_data",
					subEntity: "master_data",
					args: {
						projectId: '',
						fiscalYear: '',
						modulePrefixSaftAo: 'saft_ao'
					},
					body: "entity, count"
				},
				{
					resource: "saft_ao_transactional_data",
					args: {
						projectId: '',
						fiscalYear: '',
						modulePrefixSaftAo: 'saft_ao'
					},
					body: "entity, count"
				},
			]
		},
	],
	'pt_mod_22': [
		{
			level: 0,
			priority: 5,
			name: 'label(Model 22)',
			to: '/:projectId/:fiscalYear([0-9]{4})/statement/pt_mod_22',
			exact: true,
			icon: 'work-documents',
			navigation: [
				{
					name: ['label(Cover Page)'],
					to: '/:projectId/:fiscalYear([0-9]{4})/statement/pt_mod_22/cover_page',
				},
				{
					name: 'label(Annex A)',
					to: '/:projectId/:fiscalYear([0-9]{4})/statement/pt_mod_22/annex_a',
				},
				{
					name: 'label(Annex C)',
					to: '/:projectId/:fiscalYear([0-9]{4})/statement/pt_mod_22/annex_c',
				},
				{
					name: 'label(Annex D)',
					to: '/:projectId/:fiscalYear([0-9]{4})/statement/pt_mod_22/annex_d',
				},
			],
			routing: [
				statement('/:locale(pt|en|lt|es)?/:projectId/:fiscalYear([0-9]{4}|current)/statement/:modulePrefix(pt_mod_22)/:entity(cover_page)/:subEntity?', navigation, true, 'label(Cover Page)'),
				statement('/:locale(pt|en|lt|es)?/:projectId/:fiscalYear([0-9]{4}|current)/statement/:modulePrefix(pt_mod_22)/:entity(annex_a)/:subEntity?', navigation, true, 'label(Annex A)'),
				statement('/:locale(pt|en|lt|es)?/:projectId/:fiscalYear([0-9]{4}|current)/statement/:modulePrefix(pt_mod_22)/:entity(annex_c)/:subEntity?', navigation, true, 'label(Annex C)'),
				statement('/:locale(pt|en|lt|es)?/:projectId/:fiscalYear([0-9]{4}|current)/statement/:modulePrefix(pt_mod_22)/:entity(annex_d)/:subEntity?', navigation, true, 'label(Annex D)'),
			],
		}
	],
	'pt_mod_30': [
		{
			level: 0,
			priority: 6,
			name: 'label(Model 30)',
			to: '/:projectId/:fiscalYear([0-9]{4})/statement/pt_mod_30/file',
			exact: true,
			icon: 'work-documents',
			routing: [
				statement('/:locale(pt|en|lt|es)?/:projectId/:fiscalYear([0-9]{4}|current)/statement/:modulePrefix(pt_mod_30)/:entity(file)/:subEntity?', navigation, true, 'label(Header)'),
			],
		}
	],
	'lt_vat_report': [
		{
			priority: 3,
			name: 'label(Reports)',
			icon: 'reports',
			level: 0,
			navigation: [
				{
					name: 'label(VAT Report Invoices)',
					to: `/:projectId/:fiscalYear([0-9]{4})/reports/lt_vat_report_invoices`,
					level: 1,
					icon: 'invoices',
				},
				{
					name: 'label(VAT Report Purchase Invoices)',
					to: `/:projectId/:fiscalYear([0-9]{4})/reports/lt_vat_report_purchase_invoices`,
					level: 1,
					icon: 'invoices',
				},
			],
			routing: [
				report('/:locale(pt|en|lt|es)?/:projectId/:fiscalYear([0-9]{4}|current)/reports/:id', navigation, true, 'label(Reports)'),
			],
		}
	],
	'saft_lt': [
		{
			level: 0,
			priority: 1,
			name: 'label(Overview)',
			to: '/:projectId/:fiscalYear([0-9]{4})/',
			exact: true,
			icon: 'dashboard',
			routing: [
				overviewSaftLt('/:locale(pt|en|lt|es)?/:projectId/:fiscalYear([0-9]{4}|current)?/', navigation, true, 'label(Overview)'),
			],
			queries: [
				{
					resource: "saft_lt_audit_summary",
					args: {
						projectId: '',
						fiscalYear: '',
						modulePrefix: 'saft_lt'
					},
					body: "severity, count"
				},
			]
		},
		{
			level: 0,
			priority: 2,
			name: 'label(Audit)',
			icon: 'audit-icon',
			badge: 'number(prop(saftLtAuditSummaryTotal))',
			isToBuildMenu: true,
			navigation: [
				{
					name: ['label(Results)', ' (', 'number(prop(saftLtAuditSummaryTotal))', ')'],
					to: '/:projectId/:fiscalYear([0-9]{4})/saft_lt/audit',
				},
				{
					name: 'label(Execution Summary)',
					to: '/:projectId/:fiscalYear([0-9]{4})/saft_lt/audit_execution_summary'
				},
			],
			routing: [
				audit('/:locale(pt|en|lt|es)?/:projectId/:fiscalYear([0-9]{4}|current)/:modulePrefix(saft_lt)/audit/', navigation, true, 'label(Audit)'),
				auditSumary('/:locale(pt|en|lt|es)?/:projectId/:fiscalYear([0-9]{4}|current)/:modulePrefix(saft_lt)/audit_execution_summary', navigation, true, 'label(Execution Summary)'),
				errorFinding('/:locale(pt|en|lt|es)?/:projectId/audit_findings', navigation, true, 'label(Findings)'),
				finding('/:locale(pt|en|lt|es)?/:projectId/:fiscalYear([0-9]{4}|current)/:modulePrefix(saft_lt)/audit/rules/:entityId/finding/:id', navigation, true, 'label(Finding)'),
				findingRule('/:locale(pt|en|lt|es)?/:projectId/:fiscalYear([0-9]{4}|current)/:modulePrefix(saft_lt)/audit/rules/:id', navigation, true, 'label(Rules)'),
			],
			queries: [
				{
					resource: "saft_lt_audit_summary_total",
					args: {
						projectId: '',
						fiscalYear: '',
						modulePrefix: 'saft_lt'
					},
					body: ""
				},
			]
		},
		{
			name: 'label(SAFT-LT)',
			icon: 'xml-file',
			priority: 4,
			level: 0,
			isToBuildMenu: true,
			navigation: [
				{
					level: 1,
					name: 'label(Master Data)',
					icon: 'master-data',
					navigation: 'prop(saftLtMasterData)',
				},
				{
					level: 1,
					name: 'label(TransactionsMenu)',
					icon: 'transactions',
					navigation: 'prop(saftLtTransactionalData)'
				},
			],
			routing: [
				masterData('/:locale(pt|en|lt|es)?/:projectId/:fiscalYear([0-9]{4}|current)/:modulePrefix(saft_lt)/master_data/:entity?', navigation, true, 'label(Master Data)'),
				entity('/:locale(pt|en|lt|es)?/:projectId/:fiscalYear([0-9]{4}|current)/:modulePrefix(saft_lt)/master_data/:entities*', navigation, true, 'label(Master Data)'),
				transactions('/:locale(pt|en|lt|es)?/:projectId/:fiscalYear([0-9]{4}|current)/:modulePrefix(saft_lt)/:entity', navigation, true, 'label(TransactionsMenu)'),
				entity('/:locale(pt|en|lt|es)?/:projectId/:fiscalYear([0-9]{4}|current)/:modulePrefix(saft_lt)/:entities*', navigation, true, 'label(TransactionsMenu)'),
			],
			queries: [
				{
					resource: "saft_lt_master_data",
					subEntity: "master_data",
					args: {
						projectId: '',
						fiscalYear: '',
						modulePrefixSaftLt: 'saft_lt'
					},
					body: "entity, count"
				},
				{
					resource: "saft_lt_transactional_data",
					args: {
						projectId: '',
						fiscalYear: '',
						modulePrefixSaftLt: 'saft_lt'
					},
					body: "entity, count"
				},
			]
		},
	],
	'lt_erp': [
		{
			level: 0,
			priority: 2,
			name: 'label(Overview Erp)',
			to: '/:projectId/:fiscalYear([0-9]{4})/erp',
			exact: true,
			icon: 'dashboard',
			routing: [
				overviewErp('/:locale(pt|en|lt|es)?/:projectId/:fiscalYear([0-9]{4}|current)?/erp', navigation, true, 'label(Overview Erp)'),
			],
		},
		{
			name: 'label(LT-ERP)',
			icon: 'reports',
			priority: 5,
			level: 0,
			isToBuildMenu: true,
			navigation: [
				{
					level: 1,
					name: 'label(Master Data)',
					icon: 'master-data',
					navigation: 'prop(ltErpMasterData)',
				},
				{
					level: 1,
					name: 'label(TransactionsMenu)',
					icon: 'transactions',
					navigation: 'prop(ltErpTransactionalData)'
				},
			],
			routing: [
				masterData('/:locale(pt|en|lt|es)?/:projectId/:fiscalYear([0-9]{4}|current)/:modulePrefix(lt_erp)/master_data/:entity?', navigation, true, 'label(Master Data)'),
				entity('/:locale(pt|en|lt|es)?/:projectId/:fiscalYear([0-9]{4}|current)/:modulePrefix(lt_erp)/master_data/:entities*', navigation, true, 'label(Master Data)'),
				transactions('/:locale(pt|en|lt|es)?/:projectId/:fiscalYear([0-9]{4}|current)/:modulePrefix(lt_erp)/:entity', navigation, true, 'label(TransactionsMenu)'),
				entity('/:locale(pt|en|lt|es)?/:projectId/:fiscalYear([0-9]{4}|current)/:modulePrefix(lt_erp)/:entities*', navigation, true, 'label(TransactionsMenu)'),
			],
			queries: [
				{
					resource: "lt_erp_master_data",
					subEntity: "master_data",
					args: {
						projectId: '',
						fiscalYear: '',
						modulePrefixLtErp: 'lt_erp'
					},
					body: "entity, count"
				},
				{
					resource: "lt_erp_transactional_data",
					args: {
						projectId: '',
						fiscalYear: '',
						modulePrefixLtErp: 'lt_erp'
					},
					body: "entity, count"
				},
			]
		},
	],
	'pt_erp': [
		{
			name: 'label(PT-ERP)',
			icon: 'reports',
			priority: 5,
			level: 0,
			isToBuildMenu: true,
			navigation: [
				{
					level: 1,
					name: 'label(Master Data)',
					icon: 'master-data',
					navigation: 'prop(ptErpMasterData)',
				},
				{
					level: 1,
					name: 'label(TransactionsMenu)',
					icon: 'transactions',
					navigation: 'prop(ptErpTransactionalData)'
				}
			],
			routing: [
				masterData('/:locale(pt|en)?/:projectId/:fiscalYear([0-9]{4}|current)/:modulePrefix(pt_erp)/master_data/:entity?', navigation, true, 'label(Master Data)'),
				entity('/:locale(pt|en)?/:projectId/:fiscalYear([0-9]{4}|current)/:modulePrefix(pt_erp)/master_data/:entities*', navigation, true, 'label(Master Data)'),
				transactions('/:locale(pt|en)?/:projectId/:fiscalYear([0-9]{4}|current)/:modulePrefix(pt_erp)/:entity', navigation, true, 'label(TransactionsMenu)'),
				entity('/:locale(pt|en)?/:projectId/:fiscalYear([0-9]{4}|current)/:modulePrefix(pt_erp)/:entities*', navigation,true,'label(TransactionsMenu)'),
			],
			queries: [
				{
					resource: "pt_erp_master_data",
					subEntity: "master_data",
					args: {
						projectId: '',
						fiscalYear: '',
						modulePrefixPtErp: 'pt_erp'
					},
					body: "entity, count"
				},{
					resource: "pt_erp_transactional_data",
					subEntity: "",
					args: {
						projectId: '',
						fiscalYear: '',
						modulePrefixPtErp: 'pt_erp'
					},
					body: "entity, count"
				}
			]
		},
	],
	'i_saf_lt': [
		{
			name: 'label(I-SAF)',
			icon: 'reports',
			priority: 6,
			level: 0,
			isToBuildMenu: true,
			navigation: [
				{
					level: 1,
					name: 'label(I.SAF Master Data)',
					icon: 'master-data',
					navigation: 'prop(iSafLtMasterData)',
				},
				{
					level: 1,
					name: 'label(I.SAF Transactions)',
					icon: 'transactions',
					navigation: 'prop(iSafLtTransactionalData)'
				},
			],
			routing: [
				isafMasterData('/:locale(pt|en|lt|es)?/:projectId/:fiscalYear([0-9]{4}|current)/:modulePrefix(i_saf_lt)/master_data/:entity?', navigation, true, 'label(I.SAF Master Data)'),
				entity('/:locale(pt|en|lt|es)?/:projectId/:fiscalYear([0-9]{4}|current)/:modulePrefix(i_saf_lt)/master_data/:entities*', navigation, true, 'label(I.SAF Master Data)'),
				isafTransactions('/:locale(pt|en|lt|es)?/:projectId/:fiscalYear([0-9]{4}|current)/:modulePrefix(i_saf_lt)/:entity', navigation, true, 'label(Transactions)'),
				entity('/:locale(pt|en|lt|es)?/:projectId/:fiscalYear([0-9]{4}|current)/:modulePrefix(i_saf_lt)/:entities*', navigation, true, 'label(Transactions)'),
			],
			queries: [
				{
					resource: "i_saf_lt_master_data",
					subEntity: "master_data",
					args: {
						projectId: '',
						fiscalYear: '',
						modulePrefixISafLt: 'i_saf_lt'
					},
					body: "entity, count"
				},
				{
					resource: "i_saf_lt_transactional_data",
					args: {
						projectId: '',
						fiscalYear: '',
						modulePrefixISafLt: 'i_saf_lt'
					},
					body: "entity, count"
				},
			]
		},
	],
	'efatura':
		[
			{
				name: 'label(E-Fatura)',
				icon: 'transactions',
				priority: 7,
				level: 0,
				isToBuildMenu: true,
				navigation: [
					{
						level: 1,
						name: 'label(efatura_purchases_vs_sales_invoices)',
						icon: 'dashboard',
						to: '/:projectId/:fiscalYear([0-9]{4}|current)/efatura/overview'
					},
					{
						level: 1,
						name: 'label(Efatura Master Data)',
						icon: 'master-data',
						navigation: 'prop(efaturaMasterData)'
					},
					{
						level: 1,
						name: 'label(Efatura Transactions)',
						icon: 'transactions',
						navigation: 'prop(efaturaTransactionalData)'
					},
				],
				routing: [
					efaturaAuditFindings('/:locale(pt|en|lt|es)?/:projectId/audit_efatura_findings', navigation, true, 'label(Findings)'),
					efaturaOverviewData('/:locale(pt|en)?/:projectId/:fiscalYear([0-9]{4}|current)/:modulePrefix(efatura)/:entity(overview)?', navigation, true, 'label(Efatura)'),
					efaturaMasterData('/:locale(pt|en)?/:projectId/:fiscalYear([0-9]{4}|current)/:modulePrefix(efatura)/master_data/:entity?', navigation, true, 'label(Efatura)'),
					entity('/:locale(pt|en)?/:projectId/:fiscalYear([0-9]{4}|current)/:modulePrefix(efatura)/master_data/:entities*', navigation, true,),
					efaturaTransactionalData('/:locale(pt|en)?/:projectId/:fiscalYear([0-9]{4}|current)/:modulePrefix(efatura)/:entity?', navigation, true, 'label(Efatura)'),
					entity('/:locale(pt|en)?/:projectId/:fiscalYear([0-9]{4}|current)/:modulePrefix(efatura)/:entities*', navigation),
				],
				queries: [
					{
						resource: "efatura_transactional_data",
						args: {
							projectId: '',
							fiscalYear: '',
							modulePrefixEfatura: 'efatura'
						},
						body: "entity, count"
					},
					{
						resource: "efatura_master_data",
						subEntity: "master_data",
						args: {
							projectId: '',
							fiscalYear: '',
							modulePrefixEfatura: 'efatura'
						},
						body: "entity, count"
					},
				]
			},
		],
	'generator': [
		{
			level: 0,
			priority: 99,
			module: 'generator',
			name: 'label(i.SAF-T Generation)',
			to: '/:projectId/:fiscalYear([0-9]{4})/generation_repository',
			exact: true,
			icon: 'repository',
			routing: [
				generationRepository('/:locale(pt|en|lt|es)?/:projectId/:fiscalYear([0-9]{4}|current)/generation_repository/', navigation, true, 'label(Generation Repository)'),
			],
			queries: [
				{
					resource: "generator_repository_status",
					args: {
						projectId: '',
						fiscalYear: ''
					},
					body: "status"
				},
			]
		},
	],
	'repository':
		[
			{
				level: 0,
				priority: 100,
				name: 'label(Repository)',
				to: '/:projectId/repository/activity/status',
				exact: true,
				icon: 'repository',
				routing: [
					repository('/:locale(pt|en|lt|es)?/:projectId/repository/:section(efatura_request)', true),
					repository('/:locale(pt|en|lt|es)?/:projectId/repository/:section(efatura_deleted_data)', false),
					fileSubmission('/:locale(pt|en|lt|es)?/:projectId/repository/:section(files_submission)', true),
					repository('/:locale(pt|en|lt|es)?/:projectId/repository/:section?/:fiscalYear?/:fileType?', false),
					entityWithoutHeader('/:locale(pt|en|lt|es)?/:projectId/:entities(audit_findings)/:id', true),
					entityWithoutHeader('/:locale(pt|en|lt|es)?/:projectId/:entities(audit_efatura_findings)/:id', true),
				],
				queries: [
					{
						resource: "repository_status",
						args: {
							projectId: '',
							fiscalYear: ''
						},
						body: "status"
					},
				]
			}
		]
}

const filteredQueriesByModules = (modules) => {
	if (modules && modules.length > 0) {
		const filteredRoutes = (modules || []).reduce((acc, elem) => {
			const menuArray = menuRouting[`${elem}`]
			const queries = (menuArray || []).filter((elem) => elem.queries !== undefined).map(({ queries }) => {
				return queries
			})
			acc.push(...queries)
			return acc
		}, [])
		return filteredRoutes.flat()
	}
	return []
}

const filteredQueriesByModulesForMenu = (modules) => {
	if (modules && modules.length > 0) {
		const filteredRoutes = (modules || []).reduce((acc, elem) => {
			const menuArray = menuRouting[`${elem}`]
			const queries = (menuArray || []).filter((elem) => elem.isToBuildMenu && elem.queries !== undefined).map(({ queries }) => {
				return queries
			})

			acc.push({ [`${elem}`]: queries.flat() })
			return acc
		}, [])
		return filteredRoutes
	}
	return []
}

const filteredNavigationByModules = (modules) => {
	let filteredRoutes = []
	if (modules && modules.length > 0) {
		const reorderedArray = reorderRouting(modules)
		iterateNavigation(reorderedArray, filteredRoutes)
	}
	return filteredRoutes
}

const reorderRouting = (modules) => {
	if (modules && modules.length > 0) {
		const filteredRoutes = (modules || []).reduce((acc, elem) => {
			const menuArray = menuRouting[`${elem}`]
			if (menuArray) {
				acc.push(...menuArray)
			}
			return acc
		}, [])
		return filteredRoutes.sort(function (a, b) {
			return a.priority - b.priority;
		});
	}
	return []
}

const filteredRoutesByModules = (modules) => {
	let filteredRoutes = []
	if((modules || []).length !== 0){
		const reorderedArray = reorderRouting(modules)
		navigation.splice(0, navigation.length, ...constructMenu(reorderedArray)); //prevent navigation to duplicate entries
		iterateRouting(reorderedArray, filteredRoutes)
	}

	return filteredRoutes.flat()
}

const constructMenu = (reorderedArray) => {
	const menuToUse = [...JSON.parse(JSON.stringify(reorderedArray))] //deep copy of array, to prevent any mutation on the original routing

	const navigationContent = menuToUse.map(({routing, queries, ...restNavigation }) => {
		return restNavigation
	})

	return [...navigationContent,...defaultNavigation]
}

const iterateNavigation = (navigation, arrayOfNavigations) => {
	arrayOfNavigations.push(...navigation);
}

const iterateRouting = (navigation, arrayOfNavigations) => {
	const mergeTo = navigation.map(({ routing, queries, ...restNavigation }) => {
		if (restNavigation && Array.isArray(restNavigation)) {
			iterateRouting(restNavigation, arrayOfNavigations);
		}
		return routing || [];
	});
	arrayOfNavigations.push(...(mergeTo.flat() || []));
}

export { menuRouting, filteredQueriesByModules, filteredRoutesByModules, filteredNavigationByModules, filteredQueriesByModulesForMenu }

